import { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
import PlayerDashboard from './PlayerDashboard';

const backdropStyle = {
  position: 'fixed', inset: 0, zIndex: 999, background: 'rgba(0,0,0,0.45)',
  backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
};

const overlayStyle = {
  position: 'fixed', inset: 0, zIndex: 1000, display: 'flex',
  alignItems: 'center', justifyContent: 'center', padding: 24, pointerEvents: 'none',
};

const cardStyle = {
  pointerEvents: 'auto', background: 'rgba(255,255,255,0.08)',
  backdropFilter: 'blur(16px)', WebkitBackdropFilter: 'blur(16px)',
  border: '1px solid rgba(255,255,255,0.16)', width: '80vw', minWidth: '480px',
  maxWidth: '1200px', height: '85vh', minHeight: '500px', maxHeight: '900px',
};

const EntityModal = ({ entity, results = [], onClose }) => {
  useEffect(() => {
    if (!entity) return undefined;
    const onKey = event => { if (event.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [entity, onClose]);

  return (
    <AnimatePresence>
      {entity && (
        <>
          <motion.div key="backdrop" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }} onClick={onClose} style={backdropStyle} />
          <div style={overlayStyle}>
            <motion.div key="card" initial={{ opacity: 0, scale: 0.96, y: 12 }}
              animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0.96, y: 12 }}
              transition={{ type: 'spring', stiffness: 300, damping: 30 }} style={cardStyle}
              className="relative flex flex-col overflow-hidden rounded-2xl shadow-soft">
              <button type="button" onClick={onClose} aria-label="Close"
                className="absolute right-4 top-4 z-10 flex h-9 w-9 items-center justify-center rounded-full border border-white/20 bg-black/40 text-mute transition-colors hover:text-ink">
                <X className="h-4 w-4" />
              </button>
              <div className="flex-1 overflow-y-auto">
                <PlayerDashboard entity={entity} results={results} />
              </div>
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
};

export default EntityModal;
